module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-independence-49a7f4c82e1ed2beff20e27b25218bb3.svg";